import script from "./ContactUsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactUsModal.vue?vue&type=script&setup=true&lang=js"

import "./ContactUsModal.vue?vue&type=style&index=0&id=7bbcd9f8&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7bbcd9f8"]])

export default __exports__